import styles from "../../styles/AboutUs/MeetTheTeam.module.css";
import members from "../../Utils/Members";
import Member from "./Member";

const MeetTheTeam = () => {
  return (
    <div className={styles.meetTheTeamContainer}>
      <div className={styles.meetTheTeamInnerContainer}>
        <div className={styles.meetTheTeamTitle}>Meet The Team</div>
        <p className={styles.meetTheTeamDesc}>
          Our team is a group of passionate experts dedicated to driving
          innovation and delivering exceptional results. Get to know the people
          who make it all happen.
        </p>

        <div className={styles.membersContainer}>
          {members.map((member, index) => (
            <Member key={index} data={member} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MeetTheTeam;
